import React from '../../assets/tecs/React-icon.svg.png'
import ReactNative from '../../assets/tecs/React-native.png'

const data = [
  {
    id: 1,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    title: "JavaScript",
  },
  {
    id: 2,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    title: "TypeScript",
  },
  {
    id: 3,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    title: "Python",
  },
  {
    id: 4,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    title: "Java",
  },
  {
    id: 5,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    title: "HTML",
  },
  {
    id: 6,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    title: "CSS",
  },
  {
    id: 6,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    title: "NodeJs",
  },
  {
    id: 7,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    title: "React",
  },
  {
    id: 8,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg",
    title: "Next",
  },
  {
    id: 9,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/django/django-plain.svg",
    title: "Django",
  },
  {
    id: 10,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/spring/spring-original.svg",
    title: "SpringBoot",
  },
  {
    id: 11,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    title: "MySQL",
  },
  {
    id: 12,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original.svg",
    title: "PostgreSQL",
  },
  {
    id: 13,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    title: "MongoDB",
  },
  {
    id: 14,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original.svg",
    title: "Docker",
  },
  {
    id: 15,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/kubernetes/kubernetes-plain.svg",
    title: "Kubernetes",
  },
  {
    id: 16,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original.svg",
    title: "AWS",
  },
  {
    id: 17,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    title: "Git",
  },
  {
    id: 18,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/gitlab/gitlab-original.svg",
    title: "Git Lab",
  },
  {
    id: 19,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nginx/nginx-original.svg",
    title: "Nginx",
  },
  {
    id: 20,
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg",
    title: "Linux",
  },
];

export default data;
